module.exports = __webpack_public_path__ + "img/webBrand--billy-dash-short-icon-dark.5ef212b6.svg";